var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import ContentLoader from "react-content-loader";
import * as React from "react";
import { Grid, Typography } from "@material-ui/core";
import styled from "styled-components";
import { useTypedSelector } from "../../state/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
var StyledGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1rem;\n  color: white;\n  background-color: #213094;\n"], ["\n  padding: 1rem;\n  color: white;\n  background-color: #213094;\n"])));
var PointsText = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1.5rem !important;\n  text-align: end;\n  color: white;\n  display: inline;\n  max-height: 100%;\n\n  @media (max-width: 550px) {\n    text-align: start;\n  }\n"], ["\n  font-size: 1.5rem !important;\n  text-align: end;\n  color: white;\n  display: inline;\n  max-height: 100%;\n\n  @media (max-width: 550px) {\n    text-align: start;\n  }\n"])));
var XXS12Grid = styled(Grid)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (max-width: 550px) {\n    max-width: 100%;\n    flex-basis: 100%;\n  }\n"], ["\n  @media (max-width: 550px) {\n    max-width: 100%;\n    flex-basis: 100%;\n  }\n"])));
var PointsLabelText = styled(Typography)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 1rem !important;\n  color: white;\n\n  @media (max-width: 550px) {\n    text-align: start;\n    margin-top: 10px;\n  }\n"], ["\n  font-size: 1rem !important;\n  color: white;\n\n  @media (max-width: 550px) {\n    text-align: start;\n    margin-top: 10px;\n  }\n"])));
var IconWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 3.5rem;\n  margin: 0 1.5rem 0 0.5rem;\n  @media (max-width: 550px) {\n    text-align: center;\n  }\n"], ["\n  font-size: 3.5rem;\n  margin: 0 1.5rem 0 0.5rem;\n  @media (max-width: 550px) {\n    text-align: center;\n  }\n"])));
var RightMarginedGrid = styled(Grid)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-right: 1.5rem;\n  text-align: end;\n\n  @media (max-width: 550px) {\n    max-width: 100%;\n    flex-basis: 100%;\n    text-align: left;\n  }\n"], ["\n  margin-right: 1.5rem;\n  text-align: end;\n\n  @media (max-width: 550px) {\n    max-width: 100%;\n    flex-basis: 100%;\n    text-align: left;\n  }\n"])));
var SpaceFillerDiv = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  max-height: 31.2px;\n"], ["\n  max-height: 31.2px;\n"])));

var TopInfoBar = function TopInfoBar(_a) {
  var staticBars = _a.staticBars;
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var loggedIn = !!useTypedSelector(function (state) {
    return state.user.accessToken;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var displayBars = useTypedSelector(function (state) {
    return state.loadingBars;
  });
  var showPointsInfo = useTypedSelector(function (state) {
    return state.customization.showPointsInfo;
  });
  var title;
  var quizLabel;
  var pointsLabel;
  var receivedPoints;
  var formattedReceivedPoints;
  var availablePoints;

  if (languageInfo) {
    quizLabel = languageInfo.general.quizLabel;
    pointsLabel = languageInfo.general.pointsLabel;
  }

  var titleReplacement;
  var pointsPortion;

  if (!quiz) {
    title = "";
    formattedReceivedPoints = "";
    availablePoints = "";
    titleReplacement = displayBars || staticBars ? React.createElement(QuizTitleLoadingBar, {
      animate: !staticBars
    }) : React.createElement(SpaceFillerDiv, null);
    pointsPortion = displayBars || staticBars ? React.createElement(QuizPointsLoadingBar, {
      animate: !staticBars
    }) : React.createElement(SpaceFillerDiv, null);
  } else {
    title = quiz.texts[0].title;
    availablePoints = quiz.points;

    if (loggedIn) {
      receivedPoints = userQuizState && userQuizState.pointsAwarded ? userQuizState.pointsAwarded : 0;
      formattedReceivedPoints = Number.isInteger(receivedPoints) ? receivedPoints : receivedPoints.toFixed(2);
      pointsPortion = React.createElement(PointsText, {
        component: "div",
        paragraph: false
      }, formattedReceivedPoints + "/" + availablePoints);
    } else {
      pointsPortion = React.createElement("div", {
        style: {
          height: "31.2px"
        }
      }, React.createElement(StyledShortPointContentLoader, {
        animate: false,
        height: 25,
        width: 30,
        primaryColor: "#ffffff",
        primaryOpacity: 0.6,
        secondaryColor: "#dddddd",
        secondaryOpacity: 0.6
      }, React.createElement("rect", {
        x: "0",
        y: "0",
        rx: "10",
        ry: "10",
        width: "30",
        height: "25"
      })), React.createElement(PointsText, {
        component: "div",
        paragraph: false
      }, "/" + availablePoints));
    }
  }

  return React.createElement(StyledGrid, {
    container: true,
    justify: "space-between",
    alignItems: "flex-start"
  }, React.createElement(XXS12Grid, {
    item: true,
    xs: 9
  }, React.createElement(Grid, {
    container: true,
    alignItems: "stretch"
  }, React.createElement(XXS12Grid, {
    item: true,
    xs: 3,
    md: 2
  }, React.createElement(IconWrapper, null, React.createElement(FontAwesomeIcon, {
    icon: faQuestionCircle
  }))), React.createElement(XXS12Grid, {
    item: true,
    xs: 9,
    md: 10
  }, React.createElement(Typography, {
    variant: "subtitle1"
  }, quizLabel, ":"), quiz ? React.createElement(Typography, {
    variant: "h5"
  }, title) : titleReplacement))), (!quiz || showPointsInfo) && React.createElement(RightMarginedGrid, {
    item: true,
    xs: 2
  }, React.createElement(PointsLabelText, {
    component: "div",
    paragraph: false
  }, pointsLabel, ":"), pointsPortion));
};

var QuizTitleLoadingBar = function QuizTitleLoadingBar(_a) {
  var animate = _a.animate;
  return React.createElement(StyledQuizTitleContentLoader, {
    animate: animate,
    height: 40,
    width: 100,
    speed: 2,
    primaryColor: "#ffffff",
    primaryOpacity: 0.6,
    secondaryColor: "#dddddd",
    secondaryOpacity: 0.6
  }, React.createElement("rect", {
    x: "0",
    y: "10",
    rx: "4",
    ry: "20",
    width: "100",
    height: "30"
  }));
};

var StyledQuizTitleContentLoader = styled(ContentLoader)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 300px;\n"], ["\n  width: 100%;\n  max-width: 300px;\n"])));

var QuizPointsLoadingBar = function QuizPointsLoadingBar(_a) {
  var animate = _a.animate;
  return React.createElement(StyledQuizPointsContentLoader, {
    animate: animate,
    height: 40,
    width: 100,
    speed: 2,
    primaryColor: "#ffffff",
    primaryOpacity: 0.6,
    secondaryColor: "#dddddd",
    secondaryOpacity: 0.6
  }, React.createElement("rect", {
    x: "0",
    y: "10",
    rx: "25",
    ry: "25",
    width: "100",
    height: "30"
  }));
};

var StyledQuizPointsContentLoader = styled(ContentLoader)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 45px;\n  height: 31.2px;\n"], ["\n  width: 100%;\n  max-width: 45px;\n  height: 31.2px;\n"])));
var StyledShortPointContentLoader = styled(ContentLoader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  max-width: 35px;\n  max-height: 31.2px;\n  vertical-align: top;\n  position: relative;\n  top: 5px;\n"], ["\n  max-width: 35px;\n  max-height: 31.2px;\n  vertical-align: top;\n  position: relative;\n  top: 5px;\n"])));
export default TopInfoBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;